/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Campaign } from '../model/campaign';
import { CampaignDetailsDto } from '../model/campaignDetailsDto';
import { CampaignDto } from '../model/campaignDto';
import { CampaingResponse } from '../model/campaingResponse';
import { ProblemDetails } from '../model/problemDetails';
import { UpdateCampaignDto } from '../model/updateCampaignDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CampaignService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignCreatecampaignPost(body?: CampaignDto, observe?: 'body', reportProgress?: boolean): Observable<CampaingResponse>;
    public apiCampaignCreatecampaignPost(body?: CampaignDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaingResponse>>;
    public apiCampaignCreatecampaignPost(body?: CampaignDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaingResponse>>;
    public apiCampaignCreatecampaignPost(body?: CampaignDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CampaingResponse>('post',`${this.basePath}/api/Campaign/createcampaign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignDeleteDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiCampaignDeleteDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiCampaignDeleteDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiCampaignDeleteDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('delete',`${this.basePath}/api/Campaign/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignEditcampaignPut(body?: UpdateCampaignDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiCampaignEditcampaignPut(body?: UpdateCampaignDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiCampaignEditcampaignPut(body?: UpdateCampaignDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiCampaignEditcampaignPut(body?: UpdateCampaignDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/Campaign/editcampaign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignGetcampaignGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Campaign>;
    public apiCampaignGetcampaignGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Campaign>>;
    public apiCampaignGetcampaignGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Campaign>>;
    public apiCampaignGetcampaignGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Campaign>('get',`${this.basePath}/api/Campaign/getcampaign`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ownerid 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignGetcampaignsGet(ownerid?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CampaignDetailsDto>>;
    public apiCampaignGetcampaignsGet(ownerid?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CampaignDetailsDto>>>;
    public apiCampaignGetcampaignsGet(ownerid?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CampaignDetailsDto>>>;
    public apiCampaignGetcampaignsGet(ownerid?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ownerid !== undefined && ownerid !== null) {
            queryParameters = queryParameters.set('ownerid', <any>ownerid);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CampaignDetailsDto>>('get',`${this.basePath}/api/Campaign/getcampaigns`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ownerid 
     * @param serviceId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignGetcampaignsOwneridServiceIdGet(ownerid: string, serviceId: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CampaignDetailsDto>>;
    public apiCampaignGetcampaignsOwneridServiceIdGet(ownerid: string, serviceId: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CampaignDetailsDto>>>;
    public apiCampaignGetcampaignsOwneridServiceIdGet(ownerid: string, serviceId: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CampaignDetailsDto>>>;
    public apiCampaignGetcampaignsOwneridServiceIdGet(ownerid: string, serviceId: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ownerid === null || ownerid === undefined) {
            throw new Error('Required parameter ownerid was null or undefined when calling apiCampaignGetcampaignsOwneridServiceIdGet.');
        }

        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling apiCampaignGetcampaignsOwneridServiceIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CampaignDetailsDto>>('get',`${this.basePath}/api/Campaign/getcampaigns/${encodeURIComponent(String(ownerid))}/${encodeURIComponent(String(serviceId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
